import { NavigationLayoutList } from "#models/navigation";

export function getNavigationList(showFileManagerFn: () => void): NavigationLayoutList {
    return [
        {
            icon: "home",
            link: "/",
            text: "i18n.navigation.home",
        },
        {
            icon: "profile",
            text: "i18n.navigation.catalog",
            title: "i18n.navigation.catalog",
            submenu: true,
            defaultOpened: false,
            children: [
                {
                    can: "categoryView",
                    link: "/categories",
                    text: "i18n.navigation.categories",
                },
                {
                    can: "propertyGroupView",
                    link: "/property-groups",
                    text: "i18n.navigation.property_groups",
                },
                {
                    can: "propertyView",
                    link: "/properties",
                    text: "i18n.navigation.properties",
                },
                {
                    can: "propertyValueUnitView",
                    link: "/property-value-units",
                    text: "i18n.navigation.property_value_units",
                },
                {
                    can: "brandView",
                    link: "/brands",
                    text: "i18n.navigation.brands",
                },
                {
                    can: "productGroupView",
                    link: "/product-groups",
                    text: "i18n.navigation.product_groups",
                },
                {
                    can: "productView",
                    link: "/products",
                    text: "i18n.navigation.products",
                },
                {
                    can: "productViewStatus",
                    link: "/product-status",
                    text: "i18n.navigation.products_statuses",
                },
                {
                    can: "productReviewView",
                    link: "/product-reviews",
                    text: "i18n.navigation.product_reviews",
                },
                {
                    can: "feedbackView",
                    link: "/feedbacks",
                    text: "i18n.navigation.feedbacks",
                },
            ],
        },
        {
            icon: "team",
            link: "/clients",
            can: "clientView",
            text: "i18n.navigation.clients",
        },
        {
            icon: "reconciliation",
            link: "/orders",
            can: "orderView",
            text: "i18n.navigation.orders",
        },
        {
            icon: "menu",
            text: "i18n.navigation.content_management",
            title: "i18n.navigation.content_management",
            submenu: true,
            defaultOpened: false,
            children: [
                {
                    can: "bannerView",
                    link: "/banners",
                    text: "i18n.navigation.banners",
                },
                {
                    can: "menuView",
                    link: "/menu-manager",
                    text: "i18n.navigation.menu_manager",
                },
                {
                    can: "staticPageView",
                    link: "/static-pages",
                    text: "i18n.static_page.list_title",
                },
                {
                    can: "seoLinkView",
                    link: "/seo-routing",
                    text: "i18n.global.seo_links",
                },
                {
                    can: "seoRedirectView",
                    link: "/seo-redirects",
                    text: "i18n.navigation.seo_redirects",
                },
                {
                    can: "faqView",
                    link: "/faq",
                    text: "i18n.navigation.faq",
                },
                {
                    can: "translationView",
                    link: "/portal-translations",
                    text: "i18n.navigation.portal_translations",
                },
            ],
        },
        {
            icon: "read",
            title: "i18n.navigation.page_configs",
            text: "i18n.navigation.page_configs",
            submenu: true,
            defaultOpened: false,
            children: [
                {
                    can: "pageView",
                    link: "/pages/home-page-details",
                    text: "i18n.navigation.home",
                },
                {
                    can: "eventView",
                    link: "/events",
                    text: "i18n.navigation.ultra_events",
                },
            ],
        },
        {
            icon: "lock",
            title: "i18n.navigation.administration",
            text: "i18n.navigation.administration",
            submenu: true,
            defaultOpened: false,
            children: [
                {
                    can: "artisanCommandView",
                    link: "/cli-commands",
                    text: "i18n.navigation.cli_commands",
                },
                {
                    can: "configView",
                    link: "/config",
                    text: "i18n.navigation.configs",
                },
                {
                    can: "jobView",
                    link: "/jobs",
                    text: "i18n.navigation.jobs",
                },
                {
                    can: "jobView",
                    link: "/failed-jobs",
                    text: "i18n.navigation.failed_jobs",
                },
                {
                    can: "systemLogView",
                    link: "/system-logs",
                    text: "i18n.navigation.system_logs",
                },
                {
                    can: "deliveryView",
                    link: "/delivery-methods",
                    text: "i18n.navigation.delivery_methods",
                },
                {
                    can: "paymentMethodView",
                    link: "/payment-methods",
                    text: "i18n.navigation.payment_methods",
                },
                {
                    can: "creditProgramView",
                    link: "/credit-programs",
                    text: "i18n.navigation.credit_programs",
                },
                {
                    can: "regionView",
                    link: "/regions",
                    text: "i18n.navigation.regions",
                },
                {
                    can: "cityView",
                    link: "/cities",
                    text: "i18n.navigation.cities",
                },
                {
                    can: "userView",
                    link: "/users",
                    text: "i18n.navigation.users",
                },
                {
                    can: "roleView",
                    link: "/roles",
                    text: "i18n.navigation.roles",
                },
                {
                    can: "permissionView",
                    link: "/permissions",
                    text: "i18n.navigation.permissions",
                },
            ],
        },
        {
            link: "/megogo",
            text: "i18n.services.megogo",
            icon: "caret-up",
            submenu: true,
            defaultOpened: false,
            children: [
                {
                    can: "megogoServicesView",
                    link: "/megogo/products",
                    text: "i18n.services.megogo_products",
                },
                {
                    can: "megogoSubscriptionView",
                    link: "/megogo/subscriptions",
                    text: "i18n.services.megogo_subscriptions",
                },
            ],
        },
        {
            can: "filemanagerAccess",
            link: "/file-manager",
            text: "i18n.file_manager.button",
            icon: "cloud",
            callback: showFileManagerFn,
        },
    ];
}
